var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreadcrumDivider(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 6,
    viewBox: "0 0 3 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.303979 6C0.193212 5.99526 0.0905151 5.92863 0.0332148 5.79063C-0.0236821 5.65332 -0.00653243 5.52119 0.0792165 5.40285C0.10141 5.37236 0.127438 5.34525 0.152255 5.31725C0.753707 4.6424 1.35536 3.96755 1.95702 3.2927C2.12872 3.10005 2.12872 2.90198 1.95742 2.71001C1.34689 2.02522 0.736759 1.33998 0.12542 0.656102C0.042496 0.563502 -0.00976038 0.460739 0.00456452 0.325453C0.0201004 0.180456 0.0903137 0.0788226 0.209959 0.0271025C0.333235 -0.0261989 0.449652 -0.000451565 0.545287 0.102763C0.691968 0.261538 0.834815 0.424829 0.978873 0.586539C1.60898 1.29323 2.23888 2.00038 2.86898 2.70707C3.0433 2.90266 3.04391 3.09938 2.86938 3.29496C2.10793 4.14982 1.34568 5.00399 0.58463 5.85929C0.512601 5.94037 0.434116 5.99932 0.303979 6Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 6,
    fill: "white",
    transform: "matrix(-1 0 0 -1 3 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumDivider);
export default __webpack_public_path__ + "static/media/BreadcrumDivider.43f03de3f5d7ec6083249295a3f34236.svg";
export { ForwardRef as ReactComponent };